import { render, staticRenderFns } from "./Wenti.vue?vue&type=template&id=52ea9308&scoped=true&"
import script from "./Wenti.vue?vue&type=script&lang=js&"
export * from "./Wenti.vue?vue&type=script&lang=js&"
import style0 from "./Wenti.vue?vue&type=style&index=0&id=52ea9308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea9308",
  null
  
)

export default component.exports